import Button from '@mui/material/Button/Button';

type NavigationButtonsPropsDetails = {
  label: string;
  action: () => void;
  condition?: boolean;
  color?: 'primary' | 'error' | 'inherit' | 'secondary' | 'success' | 'info' | 'warning';
};

type NavigationButtonsProps = {
  next: NavigationButtonsPropsDetails;
  prev: NavigationButtonsPropsDetails;
};

const NavigationButtons = ({ next, prev }: NavigationButtonsProps) => {
  const hasPrev = prev?.condition ?? true;
  const hasNext = next?.condition ?? true;
  const hasNextColor = next?.color ?? 'primary';
  const hasPrevColor = prev?.color ?? 'primary';
  return (
    <div className="flex justify-between mt-4">
      {hasPrev && (
        <Button type="button" variant="contained" onClick={prev.action} color={hasPrevColor}>
          {prev.label}
        </Button>
      )}
      {hasNext && (
        <Button type="button" variant="contained" onClick={next.action} color={hasNextColor} className="ml-auto">
          {next.label}
        </Button>
      )}
    </div>
  );
};

export default NavigationButtons;
